var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import breakpoints from '../../utils/breakpoints';
import { FloatingTooltip } from './FloatingTooltip';
import { DialogTooltip } from './DialogTooltip';
export { tooltipRoles } from './Tooltip.constants';
export const Tooltip = (_a) => {
    var { dialogCloseButtonAriaLabel, role, title } = _a, rest = __rest(_a, ["dialogCloseButtonAriaLabel", "role", "title"]);
    const [isOpen, setIsOpen] = React.useState(false);
    const isWiderScreen = useMediaQuery(`(min-width: ${breakpoints._768})`);
    // TODO DSY-102: Update to support SSR but at the same time return `children` always, so that it is part of the SSR payload.
    return isWiderScreen ? (_jsx(FloatingTooltip, Object.assign({ isOpen: isOpen, role: role, setIsOpen: setIsOpen }, rest))) : (_jsx(DialogTooltip, Object.assign({ closeButtonAriaLabel: dialogCloseButtonAriaLabel, isOpen: isOpen, setIsOpen: setIsOpen, title: title }, rest)));
};
